/**
 * @generated SignedSource<<5e5a66c3a982ef8996f649b4b913ae32>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type CurrencyPreference = "EUR" | "GBP" | "USD" | "%future added value";
export type LengthUnitPreference = "CM" | "IN" | "%future added value";
export type UpdateMyProfileInput = {
  artworksPerYear?: string | null;
  bio?: string | null;
  clientMutationId?: string | null;
  collectorLevel?: number | null;
  completedOnboarding?: boolean | null;
  currencyPreference?: CurrencyPreference | null;
  email?: string | null;
  emailFrequency?: string | null;
  gender?: string | null;
  iconUrl?: string | null;
  industry?: string | null;
  isCollector?: boolean | null;
  lengthUnitPreference?: LengthUnitPreference | null;
  location?: EditableLocation | null;
  name?: string | null;
  notes?: string | null;
  otherRelevantPositions?: string | null;
  password?: string | null;
  phone?: string | null;
  priceRangeMax?: number | null;
  priceRangeMin?: number | null;
  privacy?: string | null;
  profession?: string | null;
  receiveLotOpeningSoonNotification?: boolean | null;
  receiveNewSalesNotification?: boolean | null;
  receiveNewWorksNotification?: boolean | null;
  receiveOrderNotification?: boolean | null;
  receiveOutbidNotification?: boolean | null;
  receivePartnerShowNotification?: boolean | null;
  receivePromotionNotification?: boolean | null;
  receivePurchaseNotification?: boolean | null;
  receiveSaleOpeningClosingNotification?: boolean | null;
  receiveViewingRoomNotification?: boolean | null;
  shareFollows?: boolean | null;
};
export type EditableLocation = {
  address?: string | null;
  address2?: string | null;
  city?: string | null;
  country?: string | null;
  countryCode?: string | null;
  postalCode?: string | null;
  state?: string | null;
  stateCode?: string | null;
  summary?: string | null;
};
export type useUpdateMyUserProfileMutation$variables = {
  input: UpdateMyProfileInput;
};
export type useUpdateMyUserProfileMutation$data = {
  readonly updateMyUserProfile: {
    readonly clientMutationId: string | null;
  } | null;
};
export type useUpdateMyUserProfileMutation = {
  response: useUpdateMyUserProfileMutation$data;
  variables: useUpdateMyUserProfileMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UpdateMyProfilePayload",
    "kind": "LinkedField",
    "name": "updateMyUserProfile",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "clientMutationId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useUpdateMyUserProfileMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useUpdateMyUserProfileMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "a26a005d1ab78e7ddbeda4115be42bb2",
    "id": null,
    "metadata": {},
    "name": "useUpdateMyUserProfileMutation",
    "operationKind": "mutation",
    "text": "mutation useUpdateMyUserProfileMutation(\n  $input: UpdateMyProfileInput!\n) {\n  updateMyUserProfile(input: $input) {\n    clientMutationId\n  }\n}\n"
  }
};
})();

(node as any).hash = "69ea3f3647ec583546e80aa54ebcdbe4";

export default node;
